import React from 'react';

const Bundles = () => {
  return (
    <section className="py-20 bg-zinc-900 border-y border-zinc-800">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-4xl font-black uppercase tracking-tighter mb-10 text-center">
          Expedition <span className="text-orange-500">Loadouts</span>
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Bundle 1 */}
          <div className="relative h-[500px] border border-zinc-800 group overflow-hidden">
            <div 
              className="absolute inset-0 bg-cover bg-center opacity-40 group-hover:scale-105 transition-transform duration-700"
              style={{ backgroundImage: "url('https://images.unsplash.com/photo-1504280390224-3ea153400a4e?auto=format&fit=crop&w=1000&q=80')" }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-zinc-950 via-zinc-950/80 to-transparent p-8 flex flex-col justify-end">
              <div className="mb-4">
                <span className="bg-orange-600 text-white text-xs font-bold uppercase tracking-widest px-2 py-1 mb-2 inline-block">Save 15%</span>
                <h3 className="text-3xl font-black uppercase tracking-tighter">The Alpinist Kit</h3>
              </div>
              <ul className="text-zinc-400 text-sm font-bold uppercase tracking-wide mb-6 space-y-2 border-l-2 border-orange-600 pl-4">
                <li>+ Apex Hardshell Jacket</li>
                <li>+ Granite Approach Boots</li>
                <li>+ Titanium Ice Axe</li>
              </ul>
              <div className="flex items-center justify-between">
                <span className="text-3xl font-black text-white">$850 <span className="text-lg text-zinc-500 line-through">$1000</span></span>
                <button className="bg-white text-zinc-950 px-6 py-3 font-black uppercase tracking-widest hover:bg-orange-500 hover:text-white transition-colors">
                  Select
                </button>
              </div>
            </div>
          </div>

          {/* Bundle 2 */}
          <div className="relative h-[500px] border border-zinc-800 group overflow-hidden">
            <div 
              className="absolute inset-0 bg-cover bg-center opacity-40 group-hover:scale-105 transition-transform duration-700"
              style={{ backgroundImage: "url('https://images.unsplash.com/photo-1537225228614-56cc3556d7ed?auto=format&fit=crop&w=1000&q=80')" }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-zinc-950 via-zinc-950/80 to-transparent p-8 flex flex-col justify-end">
              <div className="mb-4">
                <span className="bg-orange-600 text-white text-xs font-bold uppercase tracking-widest px-2 py-1 mb-2 inline-block">Save 20%</span>
                <h3 className="text-3xl font-black uppercase tracking-tighter">Basecamp Starter</h3>
              </div>
              <ul className="text-zinc-400 text-sm font-bold uppercase tracking-wide mb-6 space-y-2 border-l-2 border-orange-600 pl-4">
                <li>+ Polaris -20°F Sleeping Bag</li>
                <li>+ Ridge 2-Person Tent</li>
                <li>+ JetBoil System</li>
              </ul>
              <div className="flex items-center justify-between">
                <span className="text-3xl font-black text-white">$920 <span className="text-lg text-zinc-500 line-through">$1150</span></span>
                <button className="bg-white text-zinc-950 px-6 py-3 font-black uppercase tracking-widest hover:bg-orange-500 hover:text-white transition-colors">
                  Select
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Bundles;